<template>
    <div>
        <v-row>
            <v-col cols="3">
                <div class="jobs-search-bar">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                </div>
            </v-col>

            <v-col cols="6">
                <div>
                    <v-chip-group v-model="selectedFilter" multiple active-class="third--text" class="ma-4">
                        <div  v-for="item in filters" :key="item.text">
                             <v-chip>{{ item.text }}</v-chip>
                        </div>
                    </v-chip-group>
                </div>
            </v-col>

            <TableRefresh 
            :state="loading"
            @click.native="refreshTable"
        />
        </v-row>
        
        
       
        <v-data-table
            :search="search"
            :headers="headers"
            :items="filteredJobs"
            :expanded.sync="expanded"
            :loading="loading"
            item-key="id"
			sort-by="created_on"
			:sort-desc="true"
            class="elevation-1 admin-table click-row"
            @click:row="clickRow"
        >   
            <template v-slot:item.type="{ item }">
                {{ returnType(item) }}
            </template>
            <template v-slot:item.created_on="{ item }">
                {{ formateCreatedDate(item.created_on) }}
            </template>
            <template v-slot:item.due_on="{ item }">
                {{ formateDate(item.due_on) }}
            </template>
            <template v-slot:progress>
                <v-progress-linear color="blue" height="2" indeterminate></v-progress-linear>
            </template>
            <template v-slot:item.completion="{ item }">
                <v-progress-circular
                    :rotate="-90"
                    :value="convertString(item.done)"
                    :color="returnJobState(item)"
                ></v-progress-circular>
            </template>

            <template v-slot:item.refresh="{ item }">
                <RefreshLoader 
                    :id="item.id"
                    :ref="item.id"
                    :item="item"
                    @loaderClicked="refreshJob"
                />
            </template>

            <template v-slot:item.action="{ item }">
                <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                        <v-btn dark icon v-on="on" @click.stop.prevent>
                            <v-icon color="black">mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                            v-for="(opt, i) in filteredOptions"
                            :key="i"
                            :disabled="disableOpt(i, item)"
                            @click="clickOption(opt, item)"
                        >
                            <v-list-item-title>{{ opt }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <DetailedInfo
                        :key="item.id"
                        :job="selectedJob"
                        @toggleAssignmentComp="toggleAssignmentComp"
                    />
                </td>
            </template>
        </v-data-table>
        <add-job ref="addjob" :open="modal" :mode="mode" @exit="modal = false"></add-job>
        <transfer :task="task" :org="org" :open="transfer" @exit="transfer = false" />
        <DeviceAssignment
            v-if="showDeviceAssignment"
            :orgs="orgs"
            :selected-devices="selectedDevices"
            @closeDeviceAssignment="showDeviceAssignment = !showDeviceAssignment"
        />
    </div>
</template>

<script>

import { GetJobById, GetJob } from "@/services/API.js"

import RefreshLoader from '@/components/general/RefreshLoader.vue';
import DeviceAssignment from '@/views/DeviceManagement/components/DeviceAssignment.vue';
import AddJob from "./AddJob"
import Transfer from "./Transfer"
// import OTC from "./OTC"
// import ConfigStatusTable from './ConfigStatusTable';
import TableRefresh from '@/components/general/TableRefresh.vue';
import DetailedInfo from './DetailedInfo';


import { AmplifyEventBus } from "aws-amplify-vue"
import { mapState } from "vuex"

import moment from "moment"

import { Logger } from "aws-amplify"
const logger = new Logger("JobsNow")

export default {
    components: {
        // Otc: OTC,
        AddJob,
        Transfer,
        RefreshLoader,
        DeviceAssignment,
        TableRefresh,
        // ConfigStatusTable,
        DetailedInfo
    },
    props: {
        latestjob: {
            type: Object,
            required: false,
            default: () => {}
        }
    },
    data: () => ({
        abortController: null,
        search: '',
        mode: "new",
        modal: false,
        transfer: false,
        tasks: false,
        jobs: [],
        options: ["Open", "Archive", "Cancel"],
        headers: [
            { text: "Job", value: "name" },
            { text: "Type", value: "type" },
            { text: "Created On", value: "created_on" },
            { text: "Due Date", value: "due_on" },
            { text: "Created By", value: "created_by" },
            { text: "Assignee", value: "assigned_to" },
            { text: 'Assignee\'s Organisation', value: 'org' },
            { text: "Status", value: "completion" },
            { text: "Refresh", value: "refresh", sortable: false },
            { text: "Actions", value: "action", sortable: false }
        ],
        expanded: [],
        task: {},
        org: "",
        loading: true,
        jobUpdating: false,
        showDeviceAssignment: false,
        selectedDevices: [],
        installTags: [],
        selectedJob: {},

        filters: [
            { text: 'Install', val: 'taskinstall' },
            { text: 'Firmware Update', val: 'firmwareupdate'},
            { text: 'Device Config', val: 'device_config'},
        ],
        selectedFilter: []
    }),
    computed: {
        userCan () {
            return {
                Install: this.$can('createDeviceInstallJob'),
                'Firmware Update': this.$can('createFirmwareUpdateJob'),
                'Device Config': this.$can('createDeviceConfigJob'),
            }
        },
        ...mapState(["orgs"]),
        filteredJobs() {
            // filter down jobs to just the options the user can perform 
            const jobsList = this.jobs
            if(!this.selectedFilter.length) {
                return jobsList
            } 
            else {
                const filters = this.selectedFilter.map(i => this.filters[i].val)

                return jobsList.filter((job) => {
                    return job.Tasks.some(task => {
                        return filters.includes(task.task_type)
                    });
                });
            }
        },
        filteredOptions () {
            return this.options.filter(i => !this.hideOption[i])
        },
        // hide any menu options the user should not be able to use
        hideOption () {
            return {
                "Archive": !this.$can('archiveJob'),
                "Cancel": !this.$can('deleteJob')
            }
        }

    },
    watch: {
        latestjob(job) {
            this.jobs.push(job);
        }
    },
    async mounted() {
        this.abortController = new AbortController()
        this.getJobs()
        AmplifyEventBus.$on("job-now", this.handleJob)
    },
    beforeUnmount() {
        if (this.abortController) {
            this.abortController.abort()
        }
    },
    destroyed() {
        if (this.abortController) {
            this.abortController.abort()
        }
        AmplifyEventBus.$off("job-now")
    },
    methods: {
        formateCreatedDate(date) {
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        convertString(val) {
            if (!val) return '0';
            return val.toString();
        },
        returnType(job) {
            if (!job || !job.Tasks.length > 0) return ''
            const map = {
                device_config: 'Device Config',
                firmwareupdate: 'Firmware Update',
                taskinstall: 'Install'
            }
            const type = job.Tasks[0].task_type

            return map.hasOwnProperty(type) ? map[type] : ''
        },

        statusColourOptions(progress) {
            if (!progress) return 'grey';

            if (progress < 100) {
                return 'orange';
            }
            else {
                return 'green';
            }
            
        },
        returnJobState(job, returnColour = true) {
            if(!job.Tasks.length > 0) return '';

            const type = job.Tasks[0].task_type;
            const count = job.done;

            if(type == 'device_config' || type == 'firmwareupdate') {
                const items = job.Tasks[0].context.devices;
                const total = job.Tasks[0].context.devices.length;
                const pending = items.filter(item => {
                return item.status_name === "pending";
                });
                const state = (100 * (total - pending.length) / total);
                
                return returnColour ? this.statusColourOptions(state) : state;

            }
            else {
                if (isNaN(count)) return 'grey';

                return returnColour ? this.statusColourOptions(count) : count;
            }
        },
        checkJobType(item, type) {
            const tasks = item.Tasks;
            
            return tasks.length > 0 && tasks[0].task_type == type ? true : false;
        },
        configItems(list) {
            let itemList = list.Tasks[0].context.devices;

            return itemList;
        },
        returnConfig(item) {
            let task = item.Tasks[0];

            if (task.context) {
                return task.context.device_config.data;
            }
        },
        toggleAssignmentComp(device) {
            logger.info('toggleAssignmentComp ',device)
            let tags = device.context.devices.map(tag => {
               return {
                    'install_tag' : tag.install_tag,
                    'id' : tag.logical_id
               }
            });
            logger.info('tags here', tags)
            this.selectedDevices = tags;
            this.showDeviceAssignment = !this.showDeviceAssignment;
        },
        parseInstallTags(data) {
            this.installTags = data.task.context.devices.filter((tag) => !tag.vehicle_name);
        },
        formateDate(date) {
            return moment(date).format("DD/MM/YYYY")
        },
        returnOrgID(orgName) {
            let id = this.orgs.find(org => org.name === orgName);

            return id.id;
        },
        async refreshJob(item) {
            // Prevent panel from opening/closing on job refresh
            this.clickRow(item);
            const payload = {
                filters: [
                    {
                        attribute: 'id',
                        value: item.id
                    }
                ]
            }
            let refreshedJob = await GetJobById(payload);

            if (refreshedJob.Jobs) {
                window.EventBus.$emit("jobRefreshComplete");

                let latest = refreshedJob.Jobs[0];
                const targetJob = this.jobs.find(job => job.id == latest.id);

                if(targetJob) {
                    logger.info('latest job here ', latest)
                    targetJob.done = latest.Tasks.reduce((sum, task, index) => {
                        if (!task.hasOwnProperty('context')) return;
                        const complete = task.context.devices ? task.context.devices.filter(tag => tag.install_tag != '').length : 0;
                        const pending = task.context.pending_otc ? task.context.pending_otc.length : 0;

                        task.done = complete / (pending + complete)

              
                        if (index === latest.Tasks.length - 1)
                            return Math.floor(((sum + task.done) * 100) / targetJob.Tasks.length)
                        return sum + task.done
                    }, 0)

                    targetJob.Tasks[0].context.pending_otc = latest.Tasks[0].context.pending_otc;
                    targetJob.Tasks[0].context.devices = latest.Tasks[0].context.devices;
                }
                logger.info('target job', targetJob)
            }
        },
        async refreshTable() {
            this.jobs = [];
            this.getJobs();
        },
        async getJobs(page = 1) {
            // stop if navigation has occurred
            if (this.abortController?.signal.aborted) return

            let index = page;
            this.loading = true;
            let params = { 
                text_searches: [
                {
                    attribute: "archived",
                    value: "false"
                }
                ]
            }

            try {
                let res = await Promise.all([
                    GetJob(page, params, this.abortController.signal)
                ]);

                // check again after the async call returns
                if (this.abortController?.signal.aborted) return

                logger.info('paginated res : ', res)

                if (res) {
                let jobs = res[0].Jobs;
                let parsedJobs = jobs.map(job => {
                    let assigned = 0
                    job.done = job.Tasks.reduce((sum, task, index) => {
                    if (!task.hasOwnProperty('context')) return;
                    const complete = task.context.devices ? task.context.devices.filter(tag => tag.install_tag != '').length : 0;
                    const pending = task.context.pending_otc ? task.context.pending_otc.length : 0;
                    const assignedVehi = task.context.devices ? task.context.devices.filter(tag => tag.vehicle_name).length : 0;
                    task.done = complete / (pending + complete)
                    task.assigned = assignedVehi / (pending + assignedVehi)
                    task.num_devices = pending + complete
                    assigned = assigned + task.assigned
                    if (index === job.Tasks.length - 1)
                        return Math.floor(((sum + task.done) * 100) / job.Tasks.length)
                    return sum + task.done
                    }, 0)
                    job.assigned = Math.floor((assigned * 100) / job.Tasks.length)
                    job.completion = this.returnJobState(job, false)
                    return job
                })

                parsedJobs.forEach(job => {
                    if (!this.jobs.includes(job)) {
                    this.jobs.push(job);
                    }
                });

                this.loading = false;

                if (jobs.length == 100) {
                    index++
                    this.getJobs(index);
                }
                }

                logger.info('finished : ', this.jobs)
            } catch (err) {
                if (err.name === 'AbortError') return // silently stop on abort
                throw err
            }
        },
        clickOption(opt, item) {
            this.$emit(opt.toLowerCase(), item);
        },
        disableOpt(index, item) {
            switch (index) {
                case 1:
                    if (item.status !== "Pending") return false
                    return item.Tasks.some(task => {
                        if (task.context && task.context.pending_otc) {
                            task.context.pending_otc.length > 0 || task.assigned < task.done;
                        }
                    })
                default:
                    break
            }
        },
        clickRow(item) {
            logger.info('row clicked ', item)
            this.selectedJob = item;
    
            if (this.expanded[0] && this.expanded[0].id === item.id) {
                this.expanded = []
            } else {
                this.expanded = [item]

                requestAnimationFrame(() => {
                    this.$refs.slide.onResize()
                })
            }
        },
        taskHandler(item, task) {
            // if (task.done > 0 && task.done > task.assigned) {
            this.org = this.returnOrgID(item.org);
            this.task = task
            this.transfer = true
            // } else {
            // 	this.viewTask(item, task);
            // }
        },
        viewTask(item, task) {
            this.mode = Object.assign({}, item)
            this.modal = true
            this.$nextTick(() => {
                this.$refs.addjob.editTask(task)
            })
        },
        handleJob(event) {
            logger.debug('handle event : ', event)
            switch (event.action) {
                case "add":
                    this.jobs.push(event.job)
                    break

                case "modify":
                    this.jobs.some((job, i) => {
                        if (job.id === event.job.id) {
                            this.$set(this.jobs, i, event.job)
                            return true
                        }
                        return false
                    })
                    break
                case "remove":
                    this.jobs = this.jobs.filter(job => job.id !== event.job.id)
                    break
                default:
                    break
            }
        }
    }
}
</script>

<style lang="scss">
    .jobs-search-bar {
        padding-top: 1em;
        padding-left: 1em;
    }
</style>
